
import React, { useState } from "react";

const DentalImplants = () => {
  // Define hover state for boxes
  const [hoveredBox, setHoveredBox] = useState(null);

  // Function to handle mouse enter for box
  const handleMouseEnter = (index) => {
    setHoveredBox(index);
  };

  // Function to handle mouse leave for box
  const handleMouseLeave = () => {
    setHoveredBox(null);
  };

  // Box styles (dynamic based on hover state)
  const getBoxStyle = (index) => ({
    border: hoveredBox === index ? "2px solid orange" : "2px solid #ccc",
    padding: "15px",
    fontSize: "18px",
    margin: "10px",
    height: "auto",
    width: "100%",
    maxWidth: "560px",
    transition: "all 0.3s ease-in-out",
    backgroundColor: hoveredBox === index ? "#000" : "#fff",
    color: hoveredBox === index ? "#fff" : "#000",
  });

  // Heading styles (dynamic based on box hover state)
  const getHeadingStyle = (index) => ({
    color: hoveredBox === index ? "orange" : "#000",
    position: "relative",
    transition: "color 0.3s ease-in-out",
  });

  // Underline styles (visible only when the box is hovered)
  const getUnderlineStyle = (index) => ({
    content: "''",
    position: "absolute",
    bottom: "-5px",
    left: "50%",
    transform: "translateX(-50%)",
    width: hoveredBox === index ? "50%" : "0%",
    height: "2px",
    backgroundColor: "orange",
    transition: "width 0.3s ease-in-out",
  });

  return (
    <div className="textdetail" style={containerStyle}>
      <h3 style={headingStyle}>
        WHO HAS TO <span style={{ color: "orange" }}>ATTEND</span>
      </h3>
      <ul style={listStyle}>
        {boxContent.map((content, index) => (
          <li
            key={index}
            style={listItemStyle}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
          >
            <div style={getBoxStyle(index)}>
              <strong style={getHeadingStyle(index)}>
                {content.title}
                <span style={getUnderlineStyle(index)}></span>
              </strong>
              <p
                style={{
                  marginTop: "10px",
                  textAlign: "center",
                  fontFamily: "roboto",
                  fontSize: "17px",
                  
                }}
              >
                {content.description}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

// Content for the boxes
const boxContent = [
  {
    title: "1.Manufacturing and Production Professionals",
    description:
      "Individuals working on the factory floor or in production management who want to improve their understanding of digital solutions.",
  },
  {
    title: "2.Engineers and Technicians:",
    description:
      "Those in engineering roles who wish to explore how digital technologies can optimize factory processes and improve machine performance.",
  },
  {
    title: "3. 	Managers and Supervisors:",
    description:
      "Factory managers looking to implement or improve digital technologies within their production systems to increase efficiency and reduce costs.",
  },
  {
    title: "4.	Tech Enthusiasts and Students",
    description:
      "IndividAnyone interested in learning how technology is shaping the future of manufacturing and who wants to develop new skills for a career in the ",
  },
];

// Styles for the container
const containerStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "0 15px",
  width: "100%",
  maxWidth: "1200px",
  margin: "0 auto",
  marginTop: "29px",
};

const headingStyle = {
  fontSize: "30px",
  fontWeight: "bold",
  textAlign: "center",
  fontFamily: "roboto",
};

const listStyle = {
  listStyleType: "none",
  paddingLeft: "0",
  fontFamily: "Roboto",
  fontSize: "20px",
  color: "#000",
  textAlign: "center",
  width: "100%",
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between",
};

const listItemStyle = {
  marginBottom: "20px",
  width: "100%",
  maxWidth: "48%",
  boxSizing: "border-box",
  padding: "10px",
 
};

export default DentalImplants;




